import { ErrorHandler, NgModule } from '@angular/core';

import { HomemoduleRoutingModule } from './homemodule-routing.module';
// import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { SharedModule } from '../../shared/shared.module';
import { WorkpaceDiologComponent } from './workpace-diolog/workpace-diolog.component';
import { SpinnerModule } from 'src/app/shared/spinner/spinner.module';
import { WorkspaceInvitationDiologComponent } from './workspace-invitation-diolog/workspace-invitation-diolog.component';
import { WorkspaceApprovalComponent } from './workspace-approval/workspace-approval.component';
import { WorkspaceMembersComponent } from './workspace-members/workspace-members.component';
import { OrganizationModule } from '../../modules/organization/organization.module';
import { SignInComponent } from './sign-in/sign-in.component';
import { BookingsComponent } from 'src/app/shared/bookings/bookings.component';
import { ListAllWorkspacesDiologComponent } from './list-all-workspaces-diolog/list-all-workspaces-diolog.component';
import { BasicChartsModule } from 'src/app/shared/basic-charts/basic-charts.module';
import { QoutaPopupModule } from 'src/app/shared/qouta-popup/qouta.popup.module';
import { GuestModule } from './guest/guest.module';
import { MultiselectAutocompleteModule } from 'src/app/shared/multiselect-autocomplete/multiselect-autocomplete.module';
import { LoginDiologModule } from './login-dialog/login-dialog.module';

@NgModule({
  declarations: [
    // LoginDialogComponent,
    WorkpaceDiologComponent,
    WorkspaceInvitationDiologComponent,
    WorkspaceApprovalComponent,
    WorkspaceMembersComponent,
    SignInComponent,
    BookingsComponent,
    ListAllWorkspacesDiologComponent,
  ],
  imports: [
    SharedModule,
    HomemoduleRoutingModule,
    SpinnerModule,
    OrganizationModule,
    BasicChartsModule,
    QoutaPopupModule,
    // LoginGoogleModule,
    MultiselectAutocompleteModule,
    GuestModule,
    LoginDiologModule
  ],
  providers: [
    // {provide: ErrorHandler, useClass: GlobalErrorHandler}
  ],
  //exports: [NavComponent, ToolbarComponent],
})
export class HomemoduleModule {}
